
// Very simple implementation of a state machine.
export default class SimpleStateMachine {

    #states;
    #currentStateName;
    #currentState;

    constructor(states, initialStateName) {
        this.#states = states;
        this.#currentStateName = initialStateName;
        this.#currentState = states && states[initialStateName];
        this.#currentState?.onEnter();
    }


    get currentStateName() {
        return this.#currentStateName;
    }

    get currentState() {
        return this.#currentState;
    }

    changeState(toStateName) {
        if (this.#currentStateName === toStateName) {
            return;
        }

        const toState = this.#states[toStateName];

        this.#currentState.onExit();

        this.#currentStateName = toStateName;
        this.#currentState = toState;

        toState.onEnter();
    };
}